// extracted by mini-css-extract-plugin
export default {"mobileLayout":"content-confirmation_mobileLayout__VeaDb"};